import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

export const subscriptionSideBar: ThemeApp['appComponents']['subscriptionSideBar'] = {
  cardTable: {
    wrapper: {
      backgroundColor: themeUi.semantic.color.background.secondary950,
      borderRight: `1px solid ${themeUi.semantic.color.border.secondary800}`
    },
    cardsContainer: {
      padding: themeUi.core.space.space100,
      gap: themeUi.core.space.space100
    },

    card: {
      variants: {
        normal: {
          backgroundColor: themeUi.semantic.color.background.secondary900,
          borderTopColor: themeUi.semantic.color.border.secondary700,
          borderRightColor: themeUi.semantic.color.border.secondary700,
          borderBottomColor: themeUi.semantic.color.border.secondary700,
          borderLeftColor: themeUi.semantic.color.border.secondary700,
          borderRadius: '0.4rem'
        },
        selected: {
          backgroundColor: themeUi.semantic.color.background.primary950,
          borderTopColor: themeUi.semantic.color.border.primary600,
          borderRightColor: themeUi.semantic.color.border.primary600,
          borderBottomColor: themeUi.semantic.color.border.primary600,
          borderLeftColor: themeUi.semantic.color.border.primary600
        }
      },
      components: {
        cardMiddle: {
          regionText: {
            color: themeUi.semantic.color.text.secondary50
          }
        },
        cardHeader: {
          headerText: {
            color: themeUi.semantic.color.text.secondary500
          }
        },
        cardFooter: {
          databaseDetails: {
            borderRightColor: themeUi.semantic.color.border.secondary200
          },
          analyticText: {
            normalColor: themeUi.semantic.color.text.secondary200,
            selectedColor: themeUi.semantic.color.text.secondary200
          }
        }
      }
    },

    components: {
      cardTableHeader: {
        container: {
          backgroundColor: themeUi.semantic.color.background.secondary950,
          borderBottom: themeUi.semantic.color.border.secondary800
        }
      }
    },

    filter: {
      filterDropDown: {
        filterContainer: {
          borderLeft: themeUi.semantic.color.border.secondary800,
          borderRight: themeUi.semantic.color.border.secondary800
        }
      },
      filterBy: {
        categoryOptions: {
          color: themeUi.semantic.color.text.secondary50
        }
      }
    }
  }
};
